// extracted by mini-css-extract-plugin
export var dark = "r_q8";
export var darkcookie = "r_q9";
export var tintedcookie = "r_rb";
export var regularcookie = "r_rc";
export var darkbase = "r_rd";
export var tintedbase = "r_rf";
export var regularbase = "r_rg";
export var darkraw = "r_rh";
export var tintedraw = "r_rj";
export var regularraw = "r_rk";
export var darkchick = "r_rl";
export var tintedchick = "r_rm";
export var regularchick = "r_rn";
export var darkherbarium = "r_rp";
export var tintedherbarium = "r_rq";
export var regularherbarium = "r_rr";
export var darkholiday = "r_rs";
export var tintedholiday = "r_rt";
export var regularholiday = "r_rv";
export var darkoffline = "r_rw";
export var tintedoffline = "r_rx";
export var regularoffline = "r_ry";
export var darkorchid = "r_rz";
export var tintedorchid = "r_rB";
export var regularorchid = "r_rC";
export var darkpro = "r_rD";
export var tintedpro = "r_rF";
export var regularpro = "r_rG";
export var darkrose = "r_rH";
export var tintedrose = "r_rJ";
export var regularrose = "r_rK";
export var darktimes = "r_rL";
export var tintedtimes = "r_rM";
export var regulartimes = "r_rN";
export var darkwagon = "r_rP";
export var tintedwagon = "r_rQ";
export var regularwagon = "r_rR";